import api from "./api";
import endpoints from "./endpoints";

export default {
  getMasterData: async function (args) {
    const response = await api.get(endpoints.article.masterData.get, { params: args });
    return response.data;
  },
  getAllArticleStates: async function () {
    const response = await api.get(endpoints.article.allstates.get);
    return response.data;
  },
  getAlternativeArticleNumbers: async function (args) {
    const response = await api.get(endpoints.article.alternativeArticleNumbers.get, { params: args });
    return response.data;
  },
  getAttributeGroups: async function (args) {
    const response = await api.get(endpoints.article.attributeGroups.get, { params: args });
    return response.data;
  },
  getGlobalAttributes: async function (args) {
    const response = await api.get(endpoints.article.globalAttributes.get, { params: args });
    return response.data;
  },
  getVariantAttributes: async function (args) {
    const response = await api.get(endpoints.article.variantAttributes.get, { params: args });
    return response.data;
  },
  getInvariantAttributes: async function (args) {
    const response = await api.get(endpoints.article.invariantAttributes.get, { params: args });
    return response.data;
  },
  getMultiArticleVariantAttributes: async function (articleId, language, articlePagesize, articlePageOffset, attributePagesize, attributePageOffset) {
    const response = await api.get(endpoints.article.multiArticleVariantAttributes.get, {
      params: {
        articleId,
        language,
        articlePagesize,
        articlePageOffset,
        attributePagesize,
        attributePageOffset
      }
    });
    return response.data;
  },
  getErpSections: async function (args) {
    const response = await api.get(endpoints.article.erpSections.get, { params: args });
    return response.data;
  },
  getPrices: async function (args) {
    const response = await api.get(endpoints.article.prices.get, { params: args });
    return response.data;
  },
  getPriceAttributes: async function (args) {
    const response = await api.get(endpoints.article.priceAttributes.get, { params: args });
    return response.data;
  },
  getMediaAssets: async function (args) {
    const response = await api.get(endpoints.article.mediaAssets.get, { params: args });
    return response.data;
  },
  getReferences: async function (args) {
    const response = await api.get(endpoints.article.references.get, { params: args });
    return response.data;
  },
  getKeywords: async function (args) {
    const response = await api.get(endpoints.article.keywords.get, { params: args });
    return response.data;
  },
  getClassifications: async function (args) {
    const response = await api.get(endpoints.article.classifications.get, { params: args });
    return response.data;
  },
  getCatalogs: async function (args) {
    const response = await api.get(endpoints.article.catalogs.get, { params: args });
    return response.data;
  },
  getAttributeValidationStatus: async function (args) {
    const response = await api.get(endpoints.article.validationStatus, { params: args });
    return response.data;
  },
  getMultiArticleVariantAttributesValidationStatus: async function (args) {
    const response = await api.post(endpoints.article.multiArticleVariantAttributes.validationStatus, args);
    return response.data;
  },
  updateMasterData: async function (language, id, articleData) {
    const response = await api.post(endpoints.article.masterData.update, articleData, {
      params: { language, articleid: id }
    });
    return response.data;
  },
  updateAlternateArticleNumbers: async function (language, id, model) {
    const response = await api.post(endpoints.article.alternativeArticleNumbers.update, model, {
      params: { languageCode: language, articleid: id }
    });
    return response.data;
  },
  updateGlobalAttributes: async function (language, id, model) {
    const response = await api.post(endpoints.article.globalAttributes.update, model, {
      params: { language, articleid: id }
    });
    return response.data;
  },
  updateVariantAttributes: async function (language, id, model) {
    const response = await api.post(endpoints.article.variantAttributes.update, model, {
      params: { language, articleid: id }
    });
    return response.data;
  },
  updateInvariantAttributes: async function (language, id, model) {
    const response = await api.post(endpoints.article.invariantAttributes.update, model, {
      params: { language, articleid: id }
    });
    return response.data;
  },
  updateMultiArticleVariantAttributes: async function (language, id, model) {
    const response = await api.post(endpoints.article.multiArticleVariantAttributes.update, model, {
      params: { language, articleid: id }
    });
    return response.data;
  },
  updateClassifications: async function (language, id, model) {
    const response = await api.post(endpoints.article.classifications.update, model, {
      params: { language, articleid: id }
    });
    return response.data;
  },
  updateErpSections: async function (language, id, model) {
    const response = await api.post(endpoints.article.erpSections.update, model, {
      params: { language, articleid: id }
    });
    return response.data;
  },
  updatePriceAttributes: async function (language, id, model) {
    const response = await api.post(endpoints.article.priceAttributes.update, model, {
      params: { language, articleid: id }
    });
    return response.data;
  },
  updatePrices: async function (language, id, model) {
    const response = await api.post(endpoints.article.prices.update, model, {
      params: { language, articleid: id }
    });
    return response.data;
  },
  updateKeywords: async function (languages, id, keywords) {
    const response = await api.post(endpoints.article.keywords.update, { languages, keywords }, { params: { articleid: id } });
    return response.data;
  },
  updateMediaAssets: async function (language, id, mediaAssets) {
    const response = await api.post(endpoints.article.mediaAssets.update, mediaAssets, {
      params: { articleid: id, language }
    });
    return response.data;
  },
  updateReferences: async function (language, id, model) {
    const response = await api.post(endpoints.article.references.update, model, {
      params: { language, articleid: id }
    });
    return response.data;
  },
  getHirearchy: async function (articleId, catalogId) {
    const response = await api.get(endpoints.article.articleHierarchy.get, {
      params: { articleId, catalogId: catalogId || null }
    });
    return response.data;
  },
  createReferences: async function (articleId, referenceTargetId, referenceTypeId, resultLanguages, isBackReference) {
    const response = await api.post(
      endpoints.article.references.create,
      {},
      {
        params: {
          articleId,
          referenceTargetId,
          referenceTypeId,
          resultLanguages,
          isBackReference
        }
      }
    );
    return response.data;
  },
  deleteReferences: async function (articleId, articleReferenceIds) {
    const response = await api.post(endpoints.article.references.delete, articleReferenceIds, {
      params: { articleId }
    });
    return response.data;
  },
  createCrossReferences: async function (articleReferenceIds) {
    const response = await api.post(endpoints.article.references.createCrossReferences, articleReferenceIds);
    return response.data;
  },
  exchangeCrossReferences: async function (articleReferenceIds, articleId) {
    const response = await api.post(endpoints.article.references.exchangeCrossReferences, articleReferenceIds, {
      params: { articleId }
    });
    return response.data;
  },
  getDeletedArticles: async function (languageCode, abortSignal) {
    const response = await api.get(endpoints.article.deletedArticles, { params: { languageCode }, signal: abortSignal });
    return response.data;
  },
  restoreDeletedArticles: async function (articleIds, languageCode) {
    const response = await api.post(endpoints.article.restoreArticles, articleIds, { params: { languageCode } });
    return response.data;
  },
  deletePermanently: async function (articleIds) {
    const response = await api.post(endpoints.article.deletePermanently, articleIds);
    return response.data;
  },
  getVisualLinks: async function (languageCode, imagePath, signal) {
    const response = await api.get(endpoints.visualLink.get, {
      params: { languageCode, imagePath },
      signal: signal
    });
    return response.data;
  },
  saveVisualLinks: async function (visualLinkModel) {
    const response = await api.post(endpoints.visualLink.save, visualLinkModel, {});
    return response.data;
  },
  executeAttributeDefaultValueListSync: async function (language, abortSignal) {
    const response = await api.post(
      endpoints.article.defaultValueListSync,
      {},
      {
        params: { language },
        signal: abortSignal
      }
    );
    return response.data;
  },
  executeErpAttributeDefaultValueListSync: async function (language, abortSignal) {
    const response = await api.post(
      endpoints.article.erpSections.defaultValueListSync,
      {},
      {
        params: { language },
        signal: abortSignal
      }
    );
    return response.data;
  },
  executeGlobalAttributeDefaultValueListSync: async function (language, abortSignal) {
    const response = await api.post(
      endpoints.article.globalAttributes.defaultValueListSync,
      {},
      {
        params: { language },
        signal: abortSignal
      }
    );
    return response.data;
  }
};
